export const SETTINGS_SECTIONS = [
  { id: "general", label: "General", description: "Business details and scheduling preferences." },
  { id: "connections", label: "AI & connections", description: "Choose the assistant model and manage provider and integration keys." },
  { id: "spending", label: "Spending & value", description: "Control AI spending and set the assumptions used to measure automation value." },
  { id: "notifications", label: "Notifications", description: "Manage daily summaries, incident alerts, and email delivery." },
  { id: "team", label: "Team & access", description: "Manage the people and invitations for this business." },
] as const;
export type SettingsSection = typeof SETTINGS_SECTIONS[number]["id"];

